module.exports = __webpack_public_path__ + "img/comment_4_2.ad147b54.jpg";